import React from 'react'
import { Container } from '@orbitalgaming/games-frontend-library'
import { cyberColors } from '../../lib/colors'
import PageHeader from '../header/Header'
import { Main } from './gameRulesStyle'
import About from './content/About'
import PlaceABet from './content/PlaceBet'
import Elements from './content/Elements'
import Vocabulary from './content/Vocabulary'
import ScoreBoard from './content/Scoreboard'
import Chart from './content/Chart'
import Auto from './content/Auto'

export default function GameRules({ handleAbove, audio, prec, curr }: any) {
  return (
    <Container backgroundColor={cyberColors.black} padding={'21px 30px 10px'}>
      <PageHeader
        title={'Cyberdice rules'}
        func={() => handleAbove(false)}
        audio={audio}
      />
      <Main>
        <About />
        <PlaceABet curr={curr} />
        <Elements />
        <ScoreBoard />
        <Chart />
        <Auto prec={prec} curr={curr} />
        <Vocabulary />
      </Main>
    </Container>
  )
}
